import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import {
  acceptChatCall,
  rejectChatCall,
  setActiveChatCall,
  dismissIncomingCall,
} from "src/Redux/Users/Chat/userChatActions";

export default function IncomingCallModal({ incomingCall, onDismiss }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const activeChatId = useSelector((state) => state.userChat?.activeChatId);

  const handleAccept = () => {
    const { chatId, roomName, callType } = incomingCall;
    const room = roomName || `chat-${chatId}`;
    const isOnChat = location.pathname === "/chat";
    const isActiveChat = activeChatId != null && String(activeChatId) === String(chatId);
    if (!isOnChat || !isActiveChat) {
      navigate(`/chat?chat=${chatId}`);
    }
    dispatch(acceptChatCall(chatId, room));
    dispatch(setActiveChatCall({ chatId, roomName: room, callType: callType || "audio" }));
    if (typeof onDismiss === "function") onDismiss();
  };

  const handleReject = () => {
    dispatch(rejectChatCall(incomingCall.chatId));
    if (typeof onDismiss === "function") onDismiss();
  };

  const handleDismiss = () => {
    dispatch(dismissIncomingCall());
    if (typeof onDismiss === "function") onDismiss();
  };

  if (!incomingCall?.chatId) return null;

  const callerName = incomingCall.callerName || "Someone";
  const isVideo = incomingCall.callType === "video";

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90 backdrop-blur-md p-4 animate-in fade-in duration-200"
      role="dialog"
      aria-label="Incoming call"
    >
      <div
        className="border border-[var(--chat-surface)] rounded-3xl shadow-2xl max-w-sm w-full overflow-hidden bg-[#1e1e2e]"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="p-8 pb-6 flex flex-col items-center gap-6">
          <div className="w-24 h-24 rounded-full bg-gradient-to-br from-[var(--chat-primary)]/30 to-[var(--chat-primary)]/10 flex items-center justify-center ring-4 ring-[var(--chat-primary)]/20">
            <span className="material-symbols-outlined text-5xl text-[var(--chat-primary)]">
              {isVideo ? "videocam" : "call"}
            </span>
          </div>
          <div className="text-center space-y-1">
            <p className="text-[var(--chat-text-muted)] text-sm font-medium uppercase tracking-wider">
              Incoming {isVideo ? "video" : "voice"} call
            </p>
            <p className="text-xl font-bold text-white">
              {callerName}
            </p>
          </div>
          <div className="flex gap-4 w-full">
            <button
              type="button"
              onClick={handleReject}
              className="flex-1 py-3.5 rounded-2xl bg-red-500/15 text-red-400 font-semibold hover:bg-red-500/25 active:scale-[0.98] transition-all flex items-center justify-center gap-2 border border-red-500/30"
            >
              <span className="material-symbols-outlined text-xl">call_end</span>
              Decline
            </button>
            <button
              type="button"
              onClick={handleAccept}
              className="flex-1 py-3.5 rounded-2xl bg-emerald-500/20 text-emerald-400 font-semibold hover:bg-emerald-500/30 active:scale-[0.98] transition-all flex items-center justify-center gap-2 border border-emerald-500/40"
            >
              <span className="material-symbols-outlined text-xl">call</span>
              Accept
            </button>
          </div>
        </div>
        <button
          type="button"
          onClick={handleDismiss}
          className="w-full py-3 text-sm text-[var(--chat-text-muted)] hover:text-white hover:bg-white/5 border-t border-[var(--chat-surface)] transition-colors"
        >
          Dismiss
        </button>
      </div>
    </div>
  );
}
